import React from 'react';
import { connect } from 'react-redux';
import Auth from './../../auth';

const Footer = () => {
  return (
    <div id='footerContainer'>
      <Auth />
    </div>
  );
}

export default connect()(Footer);



// WEBPACK FOOTER //
// ./src/components/layout/footer/index.js